module.exports = __webpack_public_path__ + "img/second-block-bg1.daf5a13c.jpg";